import { WorldRoomEntry } from "@cleo/contracts";
import * as Schema from "effect/Schema";
import type { WorldEntryChangeOutcome } from "./worldSessionClient";
import { postLocalJson } from "./localJsonTransport";

/**
 * Archive or restore a room, confirmed by the World's read of the room with
 * one of its root sessions (rootSessionIdOf), never the whole directory.
 */
export async function setWorldRoomArchived(
  input: {
    readonly worldKey: string;
    readonly roomId: string;
    readonly archived: boolean;
    readonly expectedArchiveSeq: number;
    readonly sessionId: string;
  },
  fetchImpl: typeof fetch = fetch,
): Promise<WorldEntryChangeOutcome> {
  try {
    const response = await postLocalJson("/api/neucleos/world/rooms/archive", input, fetchImpl);
    if (response.status === 404)
      return {
        ok: false,
        kind: "unavailable",
        reason:
          "Room archive is not available on the running server yet. Update the server and retry.",
      };
    const body = await response.json();
    if (!response.ok || body?.ok !== true)
      return {
        ok: false,
        kind: typeof body?.kind === "string" ? body.kind : "transport",
        reason:
          typeof body?.reason === "string" ? body.reason : "The room change was not confirmed.",
      };
    const entry = Schema.decodeUnknownSync(WorldRoomEntry)(body.entry);
    if (
      entry.worldKey !== input.worldKey ||
      entry.room.roomId !== input.roomId ||
      entry.session.sessionId !== input.sessionId ||
      entry.room.archived !== input.archived ||
      entry.room.archiveSeq === undefined
    )
      return {
        ok: false,
        kind: "transport",
        reason: "The World did not confirm this room's archive state.",
      };
    return { ok: true, entry };
  } catch {
    return {
      ok: false,
      kind: "transport",
      reason: "The room change could not be confirmed. Refresh and retry.",
    };
  }
}
